import { createAsyncThunk } from '@reduxjs/toolkit'
import { isEmpty } from 'lodash'

import { ThunkConfig } from '@/stores/slices/Labeling/types'
import { filterLabelingItems } from '@/stores/slices/Labeling/thunks/files'

import { socket } from '@/socket'
import { API } from '@/api'
import { CreateTagObjectPayload, CreateTagToImagesPayload, LabelingNodeItem, LabelingObject } from '@/api/LabelingNode/types'

export const addTag = createAsyncThunk<LabelingNodeItem, CreateTagObjectPayload, ThunkConfig>(
  'labeling/add-tag',
  async (payload, thunkAPI) => {
    const { user } = thunkAPI.getState().user
    const { labelingNodeId, fileFilter, classTagFilters } = thunkAPI.getState().labeling

    const res = await API().Labeling.addTag(payload)

    if (!isEmpty(classTagFilters)) {
      thunkAPI.dispatch(filterLabelingItems({
        filters: fileFilter,
        isClassification: true,
        targetLabelingItemId: payload.labelingItemId,
      }))
    }

    socket?.Labeling.emitAddTag({
      nodeId: labelingNodeId,
      userId: user._id,
      userName: user.name,
      itemId: res._id,
      labelingObjects: res.labelingObjects,
    })
    return res
  }
)

export const addTagsToImages = createAsyncThunk<void, CreateTagToImagesPayload, ThunkConfig>(
  'labeling/add-tag-to-images',
  async (payload, thunkAPI) => {
    await API().Labeling.addTagToImages(payload)
    thunkAPI.dispatch(filterLabelingItems({ filters: thunkAPI.getState().labeling.fileFilter, isClassification: true }))
  }
)

export const deleteTag = createAsyncThunk<LabelingObject, string, ThunkConfig>(
  'labeling/remove-tag',
  async (objectId, thunkAPI) => {
    const { user } = thunkAPI.getState().user
    const { labelingNodeId, fileFilter, classTagFilters } = thunkAPI.getState().labeling

    const res = await API().Labeling.deleteObject(objectId)

    if (!isEmpty(classTagFilters)) {
      thunkAPI.dispatch(filterLabelingItems({
        filters: fileFilter,
        isClassification: true,
        targetLabelingItemId: res.labelingItemId,
      }))
    }

    socket?.Labeling.emitDeleteTag({
      nodeId: labelingNodeId,
      userId: user._id,
      userName: user.name,
      tagId: res._id,
      itemId: res.labelingItemId,
    })
    return res
  }
)
